export const Message = ({ data }) => {
  return (
    <x-message>
      <div class="container">
        <div class={data.severity || "warning"}>
          <span>{data.message}</span>
        </div>
      </div>
    </x-message>
  )
}
